import type { IconButtonProps } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { DeleteOutlined } from '@material-ui/icons';
import Dialog from 'components/Dialog';
import i18n from 'i18n';
import type { ReactNode } from 'react';
import { FunctionComponent } from 'react';

export interface DeleteDialogI extends IconButtonProps {
  onDelete: () => void;
  target: string;
  tooltip?: string;
  icon?: ReactNode;
  color?: 'inherit' | 'primary' | 'secondary';
  targetDeleteTitle?: string;
  targetDeletePrompt?: string;
  targetDeleteWarning?: string;
  btnDisabled?: boolean;
  lnsResource?: string;
  lnsAction?: string;
}

const DeleteDialog: FunctionComponent<DeleteDialogI> = ({
  onDelete,
  target,
  tooltip,
  targetDeleteTitle,
  targetDeletePrompt,
  targetDeleteWarning,
  color = 'secondary',
  btnDisabled = false,
  lnsResource,
  lnsAction,
  ...props
}: DeleteDialogI) => {
  return (
    <Dialog
      title={targetDeleteTitle || ''}
      tooltip={tooltip}
      openBtnLabel={i18n.t('deleteDialog.openBtnLabel')}
      iconBtn={<DeleteOutlined color={color} />}
      cancelLabel={i18n.t('button.cancel')}
      confirmLabel={i18n.t('button.confirm')}
      onConfirmCb={onDelete}
      btnDisabled={btnDisabled}
      lnsResource={lnsResource}
      lnsAction={lnsAction}
      {...props}
    >
      <Typography gutterBottom variant="body2">
        {targetDeletePrompt}
      </Typography>
      <Typography gutterBottom variant="h6">
        {target}
      </Typography>
      <Typography gutterBottom variant="body2">
        {targetDeleteWarning}
      </Typography>
    </Dialog>
  );
};

export default DeleteDialog;

DeleteDialog.defaultProps = {
  targetDeleteTitle: i18n.t('deleteDialog.title'),
  tooltip: i18n.t('deleteDialog.tooltip'),
  targetDeletePrompt: i18n.t('deleteDialog.prompt'),
  targetDeleteWarning: i18n.t('deleteDialog.warning'),
  btnDisabled: false,
  lnsResource: undefined,
  lnsAction: undefined
};
